module.exports = __webpack_public_path__ + "img/icon10.7624bb5c.png";